import { Component, ViewChild, ChangeDetectorRef, Inject, Output, EventEmitter, HostListener, ViewContainerRef, Directive, ViewEncapsulation, Type, ComponentRef, inject } from '@angular/core';
import { TopicRecord } from '@playbook/data-models/records/topic-record';
import { AssignmentRecord } from '@playbook/data-models/records/assignment-record';
import { Subject } from 'rxjs'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageSettings } from '@common/services/language-settings'
import { ModalService } from '@common/components/modal/modal.service';
import { ExternalActionsService } from '@common/services/external-actions-service';
import { ModalResponseCodes } from '@common/components/modal/modal.service';
import { ViewStateTypes } from '@common/enums/viewstate-types';
import { INavigateEvent } from '@suite/common/interfaces/i-navigate-event';
import { NavigationDirection } from '@suite/common/enums/navigation-direction';
import { TopicFullScreenDialogComponent } from './topic-full-screen/topic-full-screen';
import { AssignmentFullScreenDialogComponent } from './assignment-full-screen/assignment-full-screen';
import { takeUntil } from 'rxjs/operators';
import { Record } from '@common/data-models/records/record'
import { VisualStateService } from '../services/visual-state-service';
import { TopicService } from '@src/suite/playbook/services/topic-service';
import { NomWebServicesJson } from '../services/nom-web-services-json';
import { DataStore } from '../data-models/data-store/data-store';
import { TreeLikeFlatNode } from '../data-models/search-results/search-results';
import { AppService } from '@src/suite/app.service';


@Directive({
    selector: '[rightContainerFullScreenContent]',
})
export class RightContainerFullScreenContent {
    constructor(public viewContainerRef: ViewContainerRef) { }
}


@Directive({
    selector: '[leftContainerFullScreenContent]',
})
export class LeftContainerFullScreenContent {
    constructor(public viewContainerRef: ViewContainerRef) { }
}

@Component({
    selector: 'st-full-screen-dialog',
    templateUrl: './st-full-screen-dialog.html',
    styleUrls: ['./st-full-screen-dialog.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'st-full-screen-dialog'
    }
})
export class StFullScreenDialog {

    @ViewChild(RightContainerFullScreenContent, { static: false }) rightContainerRef!: RightContainerFullScreenContent;
    @ViewChild(LeftContainerFullScreenContent, { static: false }) leftContainerRef!: LeftContainerFullScreenContent;

    @Output()
    public navigateTo: EventEmitter<INavigateEvent> = new EventEmitter<INavigateEvent>();
    @Output()
    public createEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() public closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

    NavigationDirection = NavigationDirection;

    private _showRightPanel: boolean = false;
    get showRightPanel(): boolean {
        return this._showRightPanel;
    }

    set showRightPanel(v: boolean) {
        this._showRightPanel = v;
    }

    private _indexInData: number = 0;
    get indexInData(): number {
        return this._indexInData;
    }
    set indexInData(v: number) {
        this._indexInData = v;
    }

    private _totalCount: number = -1;
    get totalCount(): number {
        return this._totalCount;
    }
    set totalCount(v: number) {
        this._totalCount = v;
    }

    private _shouldShowTopicSwitcher: boolean = false;
    get shouldShowTopicSwitcher(): boolean {
        return !(this.showRightPanel && this.visualStateService.isLessThanMedium) && this._shouldShowTopicSwitcher;
    }
    private _isCastObject: boolean = false
    get shouldShowTopicSwitcherForCastObjects(): boolean {
        return this._isCastObject;
    }

    private _objectType: string = '';
    get objectType(): string {
        return this._objectType;
    }
    set objectType(v: string) {
        this._objectType = v;
    }


    public destroy: Subject<void> = new Subject();

    public viewStateTypes = ViewStateTypes;
    public shouldAddToGroup: boolean = false;
    public static width = -1;
    public static height = -1;
    private topicService: TopicService = null;
    private nomWebServicesJson: NomWebServicesJson

    currentIndex: number = 0;

    constructor(
        public dialogRef: MatDialogRef<StFullScreenDialog>,
        @Inject(MAT_DIALOG_DATA) public inputData: any,
        public externalActionsService: ExternalActionsService,
        public languageSettings: LanguageSettings,
        private changeDetector: ChangeDetectorRef,
        public visualStateService: VisualStateService,
        public modalService: ModalService,
        public appService: AppService
    ) {
        this.topicService = inject(TopicService);
        this.nomWebServicesJson = inject(NomWebServicesJson);
        this.currentIndex = inputData.index;
        this.shouldAddToGroup = inputData.shouldAddToGroup;
    }

    ngAfterViewInit() {
        if (StFullScreenDialog.width != -1 && StFullScreenDialog.height != -1) {
            let dialogEl: HTMLElement = document.querySelector(`.st-full-screen-dialog`);
            dialogEl.style.width = `${StFullScreenDialog.width}px`;
            dialogEl.style.height = `${StFullScreenDialog.height}px`;
        }
    }

    private _attachLeftComponent(comp: Type<TopicFullScreenDialogComponent>, data: Record = null, node?: TreeLikeFlatNode<Record>): ComponentRef<TopicFullScreenDialogComponent> {
        if (comp) {
            const containerRef = this.leftContainerRef.viewContainerRef;
            containerRef.clear();
            const component = containerRef.createComponent(comp);
            component.instance.data = data as TopicRecord;
            component.instance.changeDetectorRef.markForCheck();
            if (data.guid && this.appService.applicationName == 'playbook') {
                this._shouldShowTopicSwitcher = true;
            }
            if (node?.object?.guid && this.appService.applicationName == 'cast') {
                this._isCastObject = true
            }
            component.instance.close.pipe(takeUntil(this.destroy)).subscribe(async (res) => {
                if (!data.guid && !res?.data?.guid) {
                    const modalContent = this.languageSettings.PSTWebConfirmCancel;
                    let modalRef = this.modalService.openModal(this.languageSettings.PSTWebConformCancelShort, modalContent, this.languageSettings.PSTWebYesOption, this.languageSettings.PSTWebNoOption);
                    let modalRes;
                    try {
                        modalRes = await modalRef.result;
                    } catch (er) {
                        modalRes = ModalResponseCodes.CANCEL;
                    }
                    if (modalRes == ModalResponseCodes.OK) {
                        this.closeEvent.emit(true);
                        this.dialogRef.close();
                    }
                } else {
                    this.dialogRef.close();
                }
            });
            return component;
        }
    }

    private _attachRightComponent(comp: Type<AssignmentFullScreenDialogComponent>, data: Record = null, leftCompRef: ComponentRef<TopicFullScreenDialogComponent>): ComponentRef<AssignmentFullScreenDialogComponent> {
        if (data) {
            this.showRightPanel = true;
            this.changeDetector.detectChanges();
            const containerRef = this.rightContainerRef.viewContainerRef;
            containerRef.clear();
            const component = containerRef.createComponent(comp);
            component.instance.data = data as AssignmentRecord;
            component.instance.changeDetectorRef.markForCheck();
            component.instance.close.pipe(takeUntil(component.instance.destroyed$)).subscribe(() => {
                containerRef.clear();
                this.showRightPanel = false;
                leftCompRef.instance.selectedAssignmentIndex = -1;
                this.changeDetector.detectChanges();
            });
            return component;
        } else {
            const containerRef = this.rightContainerRef?.viewContainerRef;
            containerRef?.clear();
            this.showRightPanel = false;
            this.changeDetector.detectChanges();
        }
    }

    async openTopic(data: TopicRecord | AssignmentRecord, isMetadata: boolean = false, node?: TreeLikeFlatNode<Record>) {
        this._objectType = 'Topic';
        let currentData: TopicRecord = null;
        if (isMetadata) {
            const res = await this.topicService.getTopicContent(this.nomWebServicesJson.getDatabase(), data.path.parentCollectionPath.fullPath, data.path.parentCollectionGuid, null);
            currentData = DataStore.byGuid<TopicRecord>(res.data.guid, null);
        } else {
            currentData = data as TopicRecord;
        }
        const leftComponentRef = this._attachLeftComponent(TopicFullScreenDialogComponent, currentData, node);
        leftComponentRef.instance.onAssignmentOpen.pipe(takeUntil(this.destroy)).subscribe((index: number) => {
            leftComponentRef.instance.selectedAssignmentIndex = index;
            const newRec = currentData.children[index];
            const compRef = this._attachRightComponent(AssignmentFullScreenDialogComponent, newRec, leftComponentRef);
            compRef.instance.indexInParent = index;
            compRef.instance.onAssignmentOpened.pipe(takeUntil(compRef.instance.destroyed$)).subscribe((index: number) => {
                leftComponentRef.instance.selectedAssignmentIndex = index;
            });
            this.changeDetector.detectChanges();
        });

        leftComponentRef.instance.onAssignmentDelete.pipe(takeUntil(this.destroy)).subscribe((idx: number) => {
            if (idx == leftComponentRef.instance.selectedAssignmentIndex) {
                const containerRef = this.rightContainerRef.viewContainerRef;
                containerRef.clear();
                this.showRightPanel = false;
            }
            this.changeDetector.detectChanges();
        })

        if (!this.visualStateService.isLessThanMedium) {
            const rightComponentRef = this._attachRightComponent(AssignmentFullScreenDialogComponent, currentData.children[0], leftComponentRef);
            if (data?.guid && rightComponentRef) {
                leftComponentRef.instance.selectedAssignmentIndex = 0;

                rightComponentRef.instance.onAssignmentOpened.pipe(takeUntil(rightComponentRef.instance.destroyed$)).subscribe((index: number) => {
                    leftComponentRef.instance.selectedAssignmentIndex = index;
                });
            }
            leftComponentRef.instance.createEvent.pipe(takeUntil(leftComponentRef.instance.destroyed$)).subscribe((res) => {
                this.createEvent.emit(res);
            });
        }
    }

    openAssignment(data: AssignmentRecord, node?: TreeLikeFlatNode<Record>) {
        const leftComponentRef = this._attachLeftComponent(TopicFullScreenDialogComponent, data.parentRecord, node);
        const rightComponentRef = this._attachRightComponent(AssignmentFullScreenDialogComponent, data, leftComponentRef);
        leftComponentRef.instance.selectedAssignmentIndex = data.parentRecord.children.findIndex((rec) => rec.guid == data.guid);

        leftComponentRef.instance.onAssignmentOpen.pipe(takeUntil(this.destroy)).subscribe((index: number) => {
            leftComponentRef.instance.selectedAssignmentIndex = index;
            const newRec = data.parentRecord.children[index];
            this._attachRightComponent(AssignmentFullScreenDialogComponent, newRec, leftComponentRef);
            this.changeDetector.detectChanges();
        });

        leftComponentRef.instance.onAssignmentDelete.pipe(takeUntil(this.destroy)).subscribe((idx: number) => {
            if (idx == leftComponentRef.instance.selectedAssignmentIndex) {
                const containerRef = this.rightContainerRef.viewContainerRef;
                containerRef.clear();
                this.showRightPanel = false;
            }
            this.changeDetector.detectChanges();
        })

        rightComponentRef.instance.onAssignmentOpened.pipe(takeUntil(rightComponentRef.instance.destroyed$)).subscribe((index: number) => {
            leftComponentRef.instance.selectedAssignmentIndex = index;
        });
    }


    ngOnDestroy() {
        const dimensions = document.querySelector(`.st-full-screen-dialog`).getBoundingClientRect();
        StFullScreenDialog.width = dimensions.width;
        StFullScreenDialog.height = dimensions.height;
        this.destroy.next();
        this.destroy.complete();
    }


    @HostListener('document:keyup.arrowleft', ['$event'])
    public navigateBack(event) {
        this.navigate(event, NavigationDirection.PREVIOUS)
    }
    @HostListener('document:keyup.arrowright', ['$event'])
    public navigateForward(event) {
        this.navigate(event, NavigationDirection.NEXT)
    }
    public navigate(event, direction: NavigationDirection) {
        if (event &&
            event.target &&
            event.target.tagName &&
            !(
                event.target.tagName.toLowerCase() == 'input' ||
                event.target.tagName.toLowerCase() == 'textarea'
            )) {
            this.navigateTo.emit({ direction: direction, idx: this.currentIndex });
        }
    }
}
